import Player from "@components/Player";
import useUser from "@hooks/useUser";
import { Box, Container } from "@mui/material";
import React from "react";
import { useTokenContext } from "./auth/UserTokenProvider";
import Navigation from "./components/Navigation";
import { BackgroundFetchProvider } from "./context/BackgroundFetchContext";
import { TrackRecommendationsProvider } from "./context/TrackRecommendationsContext";
import useCurrentlyPlayingSong from "./hooks/useCurrentlyPlayingSong";
import useLyrics from "./hooks/useLyrics";
import { useTokenRefresh } from "./hooks/useTokenRefresh";
import AppRoutes from "./Routes";

interface InternalAppProps {
  toggleTheme: () => void;
  darkModeEnabled: boolean;
}

const InternalApp: React.FC<InternalAppProps> = ({ toggleTheme, darkModeEnabled }) => {
  const { token } = useTokenContext();
  const { user, isLoading: userLoading } = useUser();
  const currentlyPlayingSong = useCurrentlyPlayingSong();
  const lyrics = useLyrics(currentlyPlayingSong);
  useTokenRefresh();

  // const routeResult = useRoutes(routes);
  // useRedirect("/about/", "/about");

  return (
    <BackgroundFetchProvider currentlyPlayingSong={currentlyPlayingSong}>
      <TrackRecommendationsProvider currentlyPlayingSong={currentlyPlayingSong}>
        <div
          style={{
            display: "grid",
            gridTemplateRows: "auto minmax(0, 1fr) auto",
            height: "100%",
            minWidth: 0,
            overflow: "hidden"
          }}
        >
          <Navigation user={user} onThemeToggle={toggleTheme} isDarkMode={darkModeEnabled} />
          <Box sx={{ minHeight: 0, minWidth: 0, overflow: "auto", py: { xs: 1.5, sm: 3 } }}>
            <Container maxWidth="md" sx={{ px: { xs: 1.5, sm: 3 } }}>
              <AppRoutes
                user={user}
                userLoading={userLoading}
                currentlyPlayingSong={currentlyPlayingSong}
                lyrics={lyrics}
                onThemeToggle={toggleTheme}
                isDarkMode={darkModeEnabled}
              />
            </Container>
          </Box>
          <Player currentlyPlayingSong={currentlyPlayingSong} token={token} />
        </div>
      </TrackRecommendationsProvider>
    </BackgroundFetchProvider>
  );
};

export default InternalApp;
